import { parsePerformanceProfileJson } from '../../../Admin/Scheduling/model/PerformanceProfileTypes';
import { type CreateAircraftInput } from '../../../API';
import {
    type Aircraft,
    type AircraftAdditionalTlbData,
    type AircraftSpecialApproval,
    type AircraftTag,
} from '../../Aircrafts/types';
import { type AircraftCountableType, type AircraftUpliftableType } from '../../CountableChanges/types';
import { type DbCreated } from '../types';

export const aircraftItemFields = `
    id
    deleted
    registration
    friendlyType
    serialNumber
    imageUrl
    countableTypes
    upliftableTypes
    specialApprovals
    aircraftTypeId
    tags
    userId
    managerInternalContactId
    performanceProfile
    additionalTlbData
    _version
    _deleted
    _lastChangedAt
`.trim();

export const aircraftFromDb = (input: CreateAircraftInput & DbCreated): Aircraft => ({
    id: input.id,
    registration: input.registration,
    friendlyType: input.friendlyType,
    serialNumber: input.serialNumber,
    imageUrl: input.imageUrl || undefined,
    countableTypes: input.countableTypes ? (input.countableTypes as AircraftCountableType[]) : [],
    upliftableTypes: input.upliftableTypes ? (input.upliftableTypes as AircraftUpliftableType[]) : [],
    specialApprovals: input.specialApprovals ? (input.specialApprovals as AircraftSpecialApproval[]) : [],
    tags: input.tags ? (input.tags as AircraftTag[]) : [],
    userId: input.userId || undefined,
    managerInternalContactId: input.managerInternalContactId || null,
    aircraftTypeId: input.aircraftTypeId || null,
    deleted: input.deleted,
    performanceProfile: (input.performanceProfile && parsePerformanceProfileJson(input.performanceProfile)) || null,
    callsign: input.callsign || null,
    additionalTlbData: parseAircraftAdditionalData(input.additionalTlbData),
    _version: input._version,
});

export function parseAircraftAdditionalData(input: string | null | undefined): AircraftAdditionalTlbData {
    if (!input) {
        return {};
    }
    try {
        return JSON.parse(input);
    } catch {
        return {};
    }
}

export const aircraftToDb = (ac: Aircraft): CreateAircraftInput & DbCreated => ({
    id: ac.id,
    deleted: ac.deleted,
    registration: ac.registration,
    friendlyType: ac.friendlyType,
    serialNumber: ac.serialNumber,
    imageUrl: ac.imageUrl,
    countableTypes: ac.countableTypes,
    upliftableTypes: ac.upliftableTypes,
    specialApprovals: ac.specialApprovals,
    tags: ac.tags,
    managerInternalContactId: ac.managerInternalContactId,
    category: '(not implemented)',
    aircraftTypeId: ac._version ? ac.aircraftTypeId : undefined,
    performanceProfile: ac.performanceProfile ? JSON.stringify(ac.performanceProfile) : ac._version ? null : undefined,
    callsign: ac.callsign ? ac.callsign : ac._version ? null : undefined,
    additionalTlbData: Object.keys(ac.additionalTlbData).length ? JSON.stringify(ac.additionalTlbData) : null,
    _version: ac._version || 0,
    _lastChangedAt: ac._lastChangedAt || 0,
});
